export const translateLocation = (t, location) => {
  if (!location) return '-';
  const key = `location.${location}`;
  const translated = t(key);
  // If translation key is missing, react-i18next returns the key itself.
  return translated === key ? location : translated;
};

export const translateKeyWithFallback = (t, key, fallback) => {
  const translated = t(key);
  return translated === key ? fallback : translated;
};
